import Divider from '@zenbusiness/zui/Divider';
import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';

const ImageWrapperStyle = ({ theme }) => ({
  width: '80px',
  borderRadius: '8px',
  padding: '8px',
  marginRight: '16px',
  backgroundColor: theme.palette.background.orange.main
});

const BannerStyle = ({ theme }) => ({
  backgroundColor: theme.palette.background.grey.main,
  padding: '16px',
  borderRadius: '16px'
});

const DividerStyle = ({ theme }) => ({
  backgroundColor: theme.palette.background.orange.main,
  borderRadius: '12px',
  borderWidth: '4px',
  marginRight: '16px'
});

export const ImageWrapper = styled(Stack)(ImageWrapperStyle);
export const Banner = styled(Stack)(BannerStyle);
export const DividerStyled = styled(Divider)(DividerStyle);
